export default __webpack_public_path__ + "static/media/may2023-1.b4cf71cb.jpg";